// extracted by mini-css-extract-plugin
export default {"container":"ManualInput_container__0hfaY","box":"ManualInput_box__M0cIh"};